import { exchangeCalendarApis } from '@apis/dashboard/exchangeCalendarApis';
import { useQuery } from '@hooks/useQuery';

export const useExchangeCalendar = (start: string, end: string) => {
  return useQuery(['/exchange-calendar/', { start, end }], () =>
    exchangeCalendarApis
      .get('/exchange-calendar/', {
        query: {
          start,
          end,
          pair: 'JPY_USD',
        },
      })
      .then((r) => r[200]!),
  );
};
